/**
 * Returns an array of key/values of the enumerable properties of an object.
 * @param object - Any object
 * @signature
 *    R.toPairs(object)
 * @example
 *    R.toPairs({ a: 1, b: 2, c: 3 }) // => [['a', 1], ['b', 2], ['c', 3]]
 * @category Object
 */
export function toPairs(object) {
    return Object.entries(object);
}
export function fromPairs(data) {
    var rec = {};
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var _a = data_1[_i], k = _a[0], v = _a[1];
        rec[k] = v;
    }
    return rec;
}
